import React, { useMemo } from 'react';
import { EditableInfo } from '@icoach/components';
import { Icons, Box, Stack } from "@curves/ui-base";
import { MemberHealthCareIconButton } from '@icoach/memberDetail/components/';
import { isEqual } from '@util/utils';
import { PEOPLE_TYPE } from '@icoach/constants';
import { VALID_MEMBERSHIP_STATUSES } from "@constants/appConfig";


const HealthDeclarationBox = ({ className, healthDeclaration, memberID, membershipStatus, onEdit, healthDeclarationRedirectFrom }) => {
    const referenceType = useMemo(
        () => (VALID_MEMBERSHIP_STATUSES.some((status) => isEqual(status, membershipStatus)) ? PEOPLE_TYPE.MEMBER : PEOPLE_TYPE.INVALIDMEMBER),
        [membershipStatus],
    );
    return (
        <EditableInfo
            label={
                <Stack alignItems={'center'}>
                    <MemberHealthCareIconButton
                        className="p-0"
                        referenceType={referenceType}
                        referenceID={memberID}
                        healthDeclarationRedirectFrom={healthDeclarationRedirectFrom}
                    >
                        <Icons.Heart className="mr-1" />
                    </MemberHealthCareIconButton>
                    <Box className="editable-info__title mb-0">健康申告書</Box>
                </Stack>
            }
            onEdit={onEdit}
            className={className}
            isMultiline
        >
            {healthDeclaration || <span className={'font-color-4'}>無相關資料</span>}
        </EditableInfo>
    );
};

export default HealthDeclarationBox;
